import tw from 'twin.macro';

import { Link, useLocation } from 'react-router-dom';

const TABS = [
  { label: 'ตำแหน่งงาน', path: '/backoffice/configuration/positions' },
  { label: 'ชุดคำถาม', path: '/backoffice/configuration/templates' },
];

const ConfigurationTabs = () => {
  const location = useLocation();

  return (
    <div tw="border-b border-gray-200">
      <nav tw="flex gap-0">
        {TABS.map(({ label, path }) => {
          const isActive = location.pathname.startsWith(path);
          return (
            <Link
              key={path}
              to={path}
              css={[
                tw`px-6 py-3 text-sm font-medium transition-colors duration-100 border-b-2`,
                isActive
                  ? tw`border-primary text-primary`
                  : tw`border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300`,
              ]}
            >
              {label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default ConfigurationTabs;
